<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a
    mat-tab-link
    routerLink="pricings"
    routerLinkActive
    #rla1="routerLinkActive"
    [active]="rla1.isActive">Tareas de Proveedores</a>
  <a
    mat-tab-link
    routerLink="actions"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive">Tareas de Bodega</a>
  <a
    mat-tab-link
    routerLink="products"
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive">Consulta de Stock</a>
</nav>
<mat-tab-nav-panel #tabPanel class="wrapper" style="padding: 0;">
  <router-outlet></router-outlet>
</mat-tab-nav-panel>